import { Pane } from "components/ui"
import { Box, StackView, Button } from "@planningcenter/tapestry-react"
import { string, func } from "prop-types"
import { Link } from "@reach/router"

const BlankFormQuestion = ({ selectionsUrl, navigationPathNew, navigate }) => {
  return (
    <>
      <Pane>
        <Pane.Header distribution="start" spacing={0.5}>
          <Pane.Title className="pane__title--matchTable">Attendee information form</Pane.Title>
        </Pane.Header>

        <Pane.Body alignment="stretch" paddingTop={2}>
          <Pane.BlankState>
            <Box marginBottom={1}>
              With the attendee information form, you can add custom questions for individual
              attendees. In the <a href={selectionsUrl}>selection type settings</a>, you can also
              specify profile information to collect for each attendee.{" "}
              <a href="https://pcoregistrations.zendesk.com/hc/en-us/articles/4414934756123-Add-Attendee-Forms">
                Learn more
              </a>
            </Box>
            <StackView axis="horizontal" spacing={1} alignment="center">
              <Button
                title="Add a question"
                size="sm"
                theme="create"
                onClick={() => navigate(navigationPathNew)}
              />
              <Link
                className="btn-outline interaction sm"
                to={navigationPathNew}
                state={{ kind: "header" }}
              >
                Add section heading
              </Link>
            </StackView>
          </Pane.BlankState>
        </Pane.Body>
      </Pane>
    </>
  )
}

BlankFormQuestion.propTypes = {
  selectionsUrl: string,
  navigationPathNew: string,
  navigate: func
}

export default BlankFormQuestion
